type IGetQueryParams = (search: string, params?) => {
    accountId: string;
    chargeId: string;
    invoiceNumber: string;
    statementNumber: string;
    cidn?: string;
};

const searchDefaultParameter = '?invoiceNumber=undefined&accountId=undefined&cidn=undefined';

export const getRouteParams: IGetQueryParams = (search = searchDefaultParameter, params) => {
    const chargeId = params ? params.chargeId : null;
    const statementNumber = params ? params.statementNumber : null;
    const queryPattern = /\?invoiceNumber=.+&accountId=[0-9]/;
    const queryPatternWithCidn = /\?invoiceNumber=.+&accountId=[0-9]+&cidn=[0-9]/;
    const result = queryPattern.test(search);
    const resultWithCidn = queryPatternWithCidn.test(search);
    let invoiceNumber: string;
    let accountId: string;
    let cidn: string;
    if (result) {
        invoiceNumber = search.split('&')[0].split('=')[1];
        accountId = search.split('&')[1].split('=')[1];
    }
    if (resultWithCidn) {
        invoiceNumber = search.split('&')[0].split('=')[1];
        accountId = search.split('&')[1].split('=')[1];
        cidn = search.split('&')[2].split('=')[1];
    }
    return {
        accountId,
        chargeId,
        invoiceNumber,
        statementNumber,
        cidn
    }
}
